/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { TextInput, Loading, FormGroup, TextArea, Button, DatePickerSkeleton } from 'carbon-components-react';
import '../../scss/custom.scss';
import {
  CheckmarkOutline16,
  Send16,
  Delete16,
  Task16,
  Error16,
  Information16,
} from '@carbon/icons-react/lib/';
import { v4 as uuid } from 'uuid';
import moment from 'moment';
import SimpleReactValidator from 'simple-react-validator';
import { showNotification } from '../../helpers/notification/BaseNotification';
import {
  getError,
  getSuccess,
  apioperation,
  entitiesLabels,
  CarType,
  GetCarTypeByCode,
  DateFormat,
} from '../../helpers/Constants';
import { audit } from '../../helpers/api/api';
import AuditCAList from './AuditCAList';
import { IsEditable, CanExecuteAction } from '../../helpers/authorization/Policies';
import { AppContext } from '../../helpers/context/AppContext';
import PageBreadCrumb from '../../helpers/PageBreadCrumb';
import { WFActionModal } from '../common/WFActionModal';
import { switchDateFormat } from '../../helpers/jsonschemaform/customwidget/utils';

import { HistoryTable } from '../../helpers/HistoryTable';
import { Online } from '../common/OnLineOffLine';
import AuditRepository from '../../helpers/api/AuditRepository';
import AttachmentTable from '../common/AttachmentTable';
import DateTimePicker from '../../helpers/DateTimePicker';
import AuditFindingCADetail from './AuditFindingCADetail';


export default class AuditCARDetail extends Component {
  baseUrl;

  constructor(props) {
    super(props);
    const idAuditEdit = props ? props.match.params.id : '';
    const idAnswer = props ? props.match.params.idAnswer : '';
    const isNewCarManagement = props ? Number(props.match.params.newMng) : 0;
    const idCar = props ? props.match.params.idCar : '';

    this.state = {
      idAuditEdit,
      idAnswer,
      isNewCarManagement,
      idCar,
      isLoading: true,
      model: null,
      keyCAList: `listCA_${new Date().getTime()}`,
      // /Status Action
      isApprovalModalOpen: false,
      approvalModalAction: '',
      approver: null,
      isLoadingApproverOptions: true,
      approvalValidationMessages: [],
      approvers: [],
      // selectedData: [],
      approverRole: '',
      withApprover: true,
      isLoadingWFOperation: false,
      approvalNotesRequired: false,
      // /Status Action
      isHistoryModalOpen: false,
      currentPage: 1,
      pageSize: 10,
      rowCount: 0,
    };
    this.baseUrl = `${idAuditEdit}/answer/${idAnswer}/car/`;
    this.repository = new AuditRepository();
    this.validator = new SimpleReactValidator();
    this.validatorSolutions = new SimpleReactValidator();
    this.validatorEffectiveness = new SimpleReactValidator();
    this.previousCAItem = null;
  }

  componentDidMount() {
    this.getCAR();
  }

  showButtonHistory = () => (
    <Online>
      <Button
        className="action-button-modal"
        kind="secondary"
        renderIcon={Information16}
        onClick={() => this.openModalHistory()}
      >
        History
      </Button>
    </Online>
  );

  openModalHistory = () => {
    this.setState({ isHistoryModalOpen: true });
  };

  closeModalHistory = () => {
    this.setState({ isHistoryModalOpen: false });
  };

  setPreviousCAItem = () => {
    const item = this.state.model;
    if (item && item.ca && item.ca.length > 0) {
      this.previousCAItem = JSON.parse(JSON.stringify(item.ca[0]));
    }
  }

  isSavePendingBeforeSubmit = (carType) => {
    const item = this.state.model;
    if (this.previousCAItem && item && item.ca && item.ca.length > 0) {
      if (carType === CarType.NC.Code) { 
        return (this.previousCAItem.caImplemented !== item.ca[0].caImplemented ||
          this.previousCAItem.causeOfInefficiency !== item.ca[0].causeOfInefficiency ||
          this.previousCAItem.dueDate !== item.ca[0].dueDate ||
          this.previousCAItem.immediateThreatmentNC !== item.ca[0].immediateThreatmentNC);
      } 
      if (carType === CarType.OBS.Code) {
        return (this.previousCAItem.caImplemented !== item.ca[0].caImplemented ||
          this.previousCAItem.causeOfInefficiency !== item.ca[0].causeOfInefficiency ||
          this.previousCAItem.dueDate !== item.ca[0].dueDate);
      }
      return false;
    }
    return true;
  }

  updateCar = (caModel) => {
    const carModel = this.state.model;
    let items = carModel.ca;

    // TODO_!: il seguente commento è giusto?
    // deleteCa
    if (caModel.idAuditCAR == null) {
      const index = items.findIndex((item) => item.id === caModel);

      this.repository.updateCachedCaList(
        items[index],
        this.state.idAuditEdit,
        this.state.idAnswer,
        true
      );

      items = items.filter((x) => x.id !== caModel);

      // TODO_!: la seguente istruzione è giusta?
      this.setState((prevState) => ({
        rowCount: prevState.rowCount - 1
      }));
    } else {
      const index = items.findIndex((item) => item.id === caModel.id);
      if (index < 0) {
        items = items.concat([caModel]);
        this.setState((prevState) => ({
          rowCount: prevState.rowCount + 1,
        }));
      } else items[index] = caModel;

      this.setState({
        keyCAList: `listCA_${new Date().getTime()}`,
      });
      this.repository.updateCachedCaList(caModel, this.state.idAuditEdit, this.state.idAnswer);
    }

    this.setState((state) => {
      const { model } = state;
      const { listCas } = state;
      model.ca = items;
      listCas.itemList = items;
      return model;
    });
  };

  updateStateCarCA = (inputName, inputValue, objName) => {
    const statusCopy = { ...this.state.model };
    if (objName && objName !== 'model') statusCopy.ca[0][objName][inputName] = inputValue;
    else statusCopy.ca[0][inputName] = inputValue;

    this.setState(() => ({ model: statusCopy }));
  };

  handleChangePaging = async (page) => {
    await new Promise((resolve) => {
      this.setState(
        { currentPage: page.page, pageSize: page.pageSize, /* loading: true, isBack: false */ },
        resolve
      );
    });
    this.getCAR();
  };

  getCAR = () => {
    this.setState({
      isLoading: true,
    });

    const id = this.state.idCar;
    const filter = {
      params: {
        page: this.state.currentPage,
        pageSize: this.state.pageSize,
      },
    };
    audit
      .getWithParam(this.baseUrl + id, filter)
      .then((response) => {
        const { data } = response;
        if (data) {
          this.setState({
            model: data.result,
            listCas: data ? data.resultCas : [],
          });
          this.setPreviousCAItem();
        } else {
          showNotification.error(`${entitiesLabels.ERROR}`, 'FINDING not found');
        }
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.FINDING, apioperation.GET)
        );
        this.props.history.push(this.getBackUrl());
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  handleApproverSelect = (selectedItem) => {
    this.setState({ approver: selectedItem });
  };

  handleCloseApprovalModal = () => {
    this.setState({ isApprovalModalOpen: false }, this.clearApprovalForm);
  };

  handleApprovalNotesChange = (e) => {
    this.setState({ approvalNotes: e.target.value });
  };

  handleConfirmApprovalModal = () => {
    const apiEndpoint = this.state.approvalEndpoint;

    const data = {
      ids: [this.state.idCar],
      owner: this.state.approver,
      workflowNotes: this.state.approvalNotes,
    };

    this.setState({
      isLoadingWFOperation: true,
    });
    audit
      .put(this.baseUrl + apiEndpoint, data, '')
      .then((response) => {
        if (response.status === 200) {
          showNotification.success(
            `${entitiesLabels.SUCCESS}`,
            getSuccess(entitiesLabels.FINDING, apioperation.PUT)
          );
          this.setState({
            isLoadingWFOperation: false,
            isApprovalModalOpen: false,
            isLoading: true,
            // model: null
          });
          if (apiEndpoint === 'Delete') {
            this.props.history.push(this.getBackUrl());
          } else {
            this.getCAR();
          }
        } else {
          showNotification.error();
          this.setState({
            isLoadingWFOperation: false,
          });
        }
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.FINDING, apioperation.PUT)
        );
        this.setState({
          isLoadingWFOperation: false,
        });
      })
      .finally(() => {});
  };

  canApproveCAR = () => {
    const item = this.state.model;
    return item && item.ca && item.ca.length > 0;
  };

  canSubmitCAR = () => {
    if (this.state.isNewCarManagement === 0) {
      const item = this.state.model;
      return item && item.ca && item.ca.length > 0;
    }
    return !this.isSavePendingBeforeSubmit(this.state.model.carType);
  };

  canCloseCAR = () => {
    const item = this.state.model;
    return item && item.ca && item.ca.length > 0
      ? item.ca.filter((el) => el.idStatus === 4).length === item.ca.length
      : false;
  };

  isNotSFISTR = () => {
    const item = this.state.model;
    return item.carType !== CarType.SFI.Code && item.carType !== CarType.Strength.Code;
  }

  getStatusActions = (user, canEditResource) => {
    if (!this.IsRowSelectable()) return null;

    const { idStatus } = this.state.model;
    const leadAuditorResource = this.state.model && {
      email: this.state.model.audit.auditors.find((x) => x.teamLeader === true).email
    };
    return (
      <Online>
        <>
          {this.canSubmitCAR() &&
          CanExecuteAction('Audit', this.state.isNewCarManagement === 0 ? 'CARManagement' : 'FindingManagement', user, idStatus, 'Submit', canEditResource) && this.validator.allValid() ? (
            <Button
              renderIcon={Send16}
              onClick={() => this.state.isNewCarManagement === 0 ? this.batchActionClick('Submit', 'Submit', null, false, false, null) : this.batchActionClick('SubmitFinding', 'SubmitFinding', null, false, false, null)}
            >
              Submit FINDING
            </Button>
          ) : null}

          {this.canApproveCAR() && this.state.isNewCarManagement === 0 &&
          CanExecuteAction(
            'Audit',
            'CARManagement',
            user,
            idStatus,
            'Approve',
            canEditResource
          ) ? (
            <Button
              renderIcon={CheckmarkOutline16}
              onClick={() => this.batchActionClick('Approve', 'Approve', null, false, false, null)}
            >
              Approve FINDING
            </Button>
          ) : null}
          {/* RITM1004125 */}
          {this.canApproveCAR() && this.state.isNewCarManagement !== 0 && 
           this.validator.allValid() &&
          CanExecuteAction(
            'Audit',
            'FindingManagement',
            user,
            idStatus,
            'Open',
            leadAuditorResource
          ) && idStatus === 3 ? (
            <Button
              renderIcon={CheckmarkOutline16}
              onClick={() => this.batchActionClick('OpenFinding', 'OpenFinding', null, false, idStatus === 5, null)}
            >
              Approve FINDING
            </Button>
          ) : null}
          {this.canApproveCAR() && this.state.isNewCarManagement !== 0 && 
           this.validator.allValid() &&
          CanExecuteAction(
            'Audit',
            'FindingManagement',
            user,
            idStatus,
            'Open',
            leadAuditorResource
          ) && idStatus === 5 ? (
            <Button
              renderIcon={CheckmarkOutline16}
              onClick={() => this.batchActionClick('OpenFinding', 'OpenFinding', null, false, idStatus === 5, null)}
            >
              Open FINDING
            </Button>
          ) : null}
          {/* End */}
          {this.canCloseCAR() && this.state.isNewCarManagement === 0 &&
          CanExecuteAction(
            'Audit',
            'CARManagement',
            user,
            idStatus,
            'Consolidate',
            canEditResource
          ) ? (
            <Button
              renderIcon={CheckmarkOutline16}
              onClick={() => this.batchActionClick('Close', 'Close', null, false, false, null)}
            >
              Close FINDING
            </Button>
          ) : null}

          {this.state.isNewCarManagement !== 0 && this.validatorSolutions.allValid() &&
          CanExecuteAction(
            'Audit',
            'FindingManagement',
            user,
            idStatus,
            'Close',
            canEditResource
          ) ? (
            <Button
              renderIcon={CheckmarkOutline16}
              onClick={() => this.batchActionClick('CloseFinding', 'CloseFinding', null, false, false, null)}
            >
              Close FINDING
            </Button>
          ) : null}

          {this.state.isNewCarManagement !== 0 && this.validatorSolutions.allValid() && 
          CanExecuteAction(
            'Audit',
            'FindingManagement',
            user,
            idStatus,
            'Complete',
            leadAuditorResource
          ) && this.isNotSFISTR() ? (
            <Button
              renderIcon={CheckmarkOutline16}
              onClick={() => this.batchActionClick('CompleteFinding', 'CompleteFinding', null, false, false, null)}
            >
              Complete FINDING
            </Button>
          ) : null}


          {this.state.isNewCarManagement === 0 &&
          CanExecuteAction('Audit', 'CARManagement', user, idStatus, 'Open', canEditResource) ? (
            <Button
              renderIcon={CheckmarkOutline16}
              onClick={() => this.batchActionClick('Open', 'Open', null, false, false, null)}
            >
              Open FINDING
            </Button>
          ) : null}

          {CanExecuteAction('Audit', this.state.isNewCarManagement === 0 ? 'CARManagement' : 'FindingManagement', user, idStatus, 'Reject', this.state.isNewCarManagement === 0 ? canEditResource : leadAuditorResource) ? (
            <Button
              renderIcon={Error16}
              onClick={() => this.state.isNewCarManagement === 0 ? this.batchActionClick('Reject', 'Reject', null, false, true, null) : this.batchActionClick('RejectFinding', 'RejectFinding', null, false, true, null)}
            >
              {this.state.isNewCarManagement === 0 ? 'Reject FINDING' : 'Reject'} 
            </Button>
          ) : null}

          {CanExecuteAction('Audit', this.state.isNewCarManagement === 0 ? 'CARManagement' : 'FindingManagement', user, idStatus, 'Delete', canEditResource) && !this.state.model?.audit?.maskedValue ? ( //RITM1133680
            <Button
              renderIcon={Delete16}
              onClick={() => this.batchActionClick('Delete', 'Delete', null, false, false, null)}
            >
              Delete
            </Button>
            
          ) : null}

          { this.state.isNewCarManagement !== 0 && CanExecuteAction('Audit', 'FindingManagement', user, idStatus, 'Assign', canEditResource) ? (
            <Button
              renderIcon={Task16}
              onClick={() => this.batchActionClick('AssignFinding', 'AssignFinding', null, false, false, null)}
            >
              {this.isNotSFISTR() ? 'Assign Finding' : 'Close Finding'}
            </Button>
            
          ) : null}
        </>
      </Online>
    );
  };

  getBackUrl = () => 
    // const { hash } = this.props.location;
    // if (hash) {
    //   return `/audit/${this.state.idAuditEdit}/car/`;
    // }
    // return  ;
    // const hash = this.props.location.hash || '';
     `/audit/${this.state.idAuditEdit}/${this.state.isNewCarManagement}/car/`
    // return `/audit/${this.state.idAuditEdit}/answer/${this.state.idAnswer}/car/${hash}`;

    // if (this.props.history.length == 1)
    //     console.log("TODO, Chiudere la pagina???")
    // else
    //     this.props.history.goBack()
  ;

  updateActualCompletion = (_, value) => 
    this.setState((prevState) => ({ model: { ...prevState.model, actualDateCompletition: value } }))

  clearAttachment = () => ({
    id: null, // guid
    fileIdentifier: null,
    name: null,
    contentType: null,
    size: null,
    type: null,
  });

  onUploadFiles = (fileIdentifier, fileName, fileType, size) => {
    const attachment = { ...this.state.attachment };

    attachment.id = uuid();
    attachment.fileIdentifier = fileIdentifier.blobName;
    attachment.name = fileName;
    attachment.contentType = fileType;
    attachment.size = size;
    // attachment.filePath = file.localPath;

    this.setState({
      attachment: this.clearAttachment(),
    });

    try {
      if (attachment == null) return;
      // insert
      const oldattachment = this.state.model.attachment || [];

      const newItem = {
        id: uuid(), // guid

        idAttachment: attachment.id, // guid
        attachment,
      };

      const newattachment = oldattachment.concat([newItem]);
      this.setState((prevState) => ({ model: { ...prevState.model, attachment: newattachment } }));
    } catch (error) {
      showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.ATTACHMENT, apioperation.UPLOAD));
    }
  };

  onRemoveFile = (id) => {
    if (!id) return;
    this.setState((prevState) => {
      const statusCopy = { ...prevState.model };
      statusCopy.attachment = statusCopy.attachment.filter((el) => el.id !== id);
      return { model: statusCopy }; 
    });
  };

  saveNewMng = () => {
    if (this.state.isNewCarManagement !== 0 && this.state.model?.idStatus >= 6 && 
       (this.state.model.carType === CarType.NC.Code || 
        this.state.model.carType === CarType.OBS.Code) &&
        !this.validatorEffectiveness.allValid()) { 
      // ATTENZIONE da attivare quando il Finding passa in stato Completed
      showNotification.warning(`${entitiesLabels.WARNING}`, 'field not valid');
      this.validatorEffectiveness.showMessages();
      this.forceUpdate();
      return;
    }
    if (this.state.isNewCarManagement !== 0 && this.state.model?.idStatus >= 4 && 
       (this.state.model.carType === CarType.NC.Code || 
        this.state.model.carType === CarType.OBS.Code) &&
        !this.validatorSolutions.allValid()) {
          showNotification.warning(`${entitiesLabels.WARNING}`, ` ${entitiesLabels.CA} required fields are missing  `);
          this.validatorSolutions.showMessages();
          this.forceUpdate();
          return;
    }
    if (this.state.isNewCarManagement !== 0 && 
      (this.state.model.carType === CarType.NC.Code || 
      this.state.model.carType === CarType.OBS.Code) && !this.validator.allValid()) {
      if (this.validator.fieldValid('duedate') === false) {
        showNotification.warning(
          `${entitiesLabels.WARNING}`,
          'The Due Date must be less than or equal to the Due Date of the Finding '
        );
      } else {
        showNotification.warning(
          `${entitiesLabels.WARNING}`,
          ` ${entitiesLabels.CA} required fields are missing  `
        );
      }
      this.validator.showMessages();
      this.forceUpdate();
      return;
    }

    const { model } = this.state;
    model.id = this.state.idCar;
    model.idAudit = this.state.idAuditEdit;
    model.idAnswer = this.state.idAnswer;
    
    const backendBaseUrl = `${model.idAudit}/answer/${model.idAnswer}/findingfromdetails/`;
    const method = audit.put(backendBaseUrl, model, model.id);
    this.setState(() => ({ isSubmitted: true }));

    method
      .then((response) => {
        if (response.status === 200) {
          showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.FINDING, apioperation.PUT));
          this.setPreviousCAItem();
        } else {
          showNotification.error();
        }
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.FINDING, apioperation.PUT));
      })
      .finally(() => {
        this.setState(() => ({ isSubmitted: false }));
      });
  } 

    save = () => {
      const { model } = this.state;
      model.id = this.state.idCar;
      model.idAudit = this.state.idAuditEdit;
      model.idAnswer = this.state.idAnswer;
      const postBackUrl = `${model.idAudit}/answer/${model.idAnswer}/carfromdetails/`;
      const method = audit.put(postBackUrl, model, model.id);
      this.setState({ isSubmitted: true });

      method
      .then((response) => {
        if (response.status === 200) {  
          showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.FINDING, this.state.isEditModalCAR ? apioperation.PUT : apioperation.POST));
        }
        this.setPreviousCAItem();
        this.forceUpdate();
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.FINDING, apioperation.PUT));
      })
      .finally(() => {
        this.setState({
          isSubmitted: false,
        });
      }); 
    }

    // CA Attachments management
    onDeleteFileCA = (id) => {
      if (!id) return;
      if (this.state.isNewCarManagement === 0) return;
  
      const statusCopy = { ...this.state.model };
      statusCopy.ca[0].attachment = statusCopy.ca[0].attachment.filter((el) => el.id !== id);
      this.setState(() => ({ model: statusCopy }));
    };

    onUploadFileCA = (fileIdentifier, fileName, fileType, size) => {
      if (this.state.isNewCarManagement === 0) return;
      const attachment = { ...this.state.attachment };
  
      attachment.id = uuid();
      attachment.fileIdentifier = fileIdentifier.blobName;
      attachment.name = fileName;
      attachment.contentType = fileType;
      attachment.size = size;
  
      this.setState({
        attachment: this.clearAttachment(),
      });
  
      try {
          if (attachment == null) return;
          // insert
          const oldattachment = this.state.model.ca[0].attachment || [];
    
          const newItem = {
            id: uuid(), // guid
            idAttachment: attachment.id, // guid
            attachment,
          };
    
          const newattachment = oldattachment.concat([newItem]);
          this.updateStateCarCA('attachment', newattachment, 'model');
      } catch (error) {
          showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.CA, apioperation.UPLOAD));
        }
    }

    showLoading() {
      const show = this.state.isLoading || this.state.isSubmitted;
      const descr = this.state.isSubmitted ? 'Saving...' : 'Loading data...';
      return show && <Loading active withOverlay description={descr} />;
      // return (<InlineLoading className="bx--loading-overlay" {...props} />)
    }

    IsRowSelectable() {
      const row = this.state.model;
      if (row == null) return false; 
  
      return true;
    }

    batchActionClick(
      actionKey,
      actionName,
      approverRole,
      withApprover,
      approvalNotesRequired
      // selectedRows
    ) {
      this.setState({
        approvalModalAction: actionName,
        isApprovalModalOpen: true,
        isLoadingApproverOptions: true,
        withApprover,
        // selectedData: selectedRows,
        approverRole,
        approvalEndpoint: actionKey,
        approvalNotesRequired,
      });
    }

  render() {
    const auditCA = this.state.model
      ? this.state.model.ca
          .filter((x) => this.state.listCas?.itemList.some((y) => y.id === x.id))
          .slice(0, this.state.pageSize)
      : null;

    const CAListProps = {
      key: this.state.keyCAList,
      idAuditEdit: this.state.idAuditEdit,
      idAnswer: this.state.idAnswer,
      isNewCarManagement: this.state.isNewCarManagement,
      isLoading: this.state.isLoading,
      idCar: this.state.idCar,
      auditCA,
      history: this.props.history,
      match: this.props.match,
      getCAs: this.updateCar,
      hash: this.props.location.hash,
      statusCar: this.state.model?.idStatus,
      statusAuditReport: this.state.model?.audit?.checkList?.idStatus,
      listCa: this.state.listCas,
      currentPage: this.state.listCas?.currentPage || 1,
      pageSize: this.state.listCas?.pageSize || 10,
      rowCount: this.state.model?.ca?.length || 0,
      handleChangePaging: this.handleChangePaging,
      maskedValue: this.state.model?.audit?.maskedValue, //RITM1133680
    };

    let diffduedate = true;
    if (this.state.isNewCarManagement !== 0 && this.state.model?.ca.length > 0
        && this.state.model?.ca[0].dueDate != null) {
      diffduedate =
        !this.state.model?.dueDate ||
        moment(this.state.model?.dueDate).isSameOrAfter(moment(this.state.model?.ca[0].dueDate), 'day');
    } else {
      diffduedate = true;
    }

    const validationsCA = (this.state.isNewCarManagement !== 0 ? {
      duedate: this.validator.message(
        'duedate', 
        (this.state.model?.carType === CarType.NC.Code || 
         this.state.model?.carType === CarType.OBS.Code) ? diffduedate : true,
        'accepted'),
      dueDate: this.validator.message(
        'dueDate', 
        (this.state.model?.carType === CarType.NC.Code || 
         this.state.model?.carType === CarType.OBS.Code) ? this.state.model?.ca[0].dueDate : true,
        'required'),
      immediateThreatmentNC: this.validator.message(
        'immediateTreatmentnc',
        this.state.model?.carType === CarType.NC.Code ?
         this.state.model?.ca[0].immediateThreatmentNC : true,
        'required'
      ),
      causeOfInefficiency: this.validator.message(
        'causeOfInefficiency',
        (this.state.model?.carType === CarType.NC.Code || 
         this.state.model?.carType === CarType.OBS.Code) ? 
          this.state.model?.ca[0].causeOfInefficiency : true,
        'required'
      ),
      caImplemented: this.validator.message(
        'caImplemented',
        (this.state.model?.carType === CarType.NC.Code ||
         this.state.model?.carType === CarType.OBS.Code) ?
          this.state.model?.ca[0].caImplemented : true,
        'required'
      ),
     } : null);

     const validationCASolution = (this.state.isNewCarManagement !== 0 ? {
      immediateThreatment: this.validatorSolutions.message(
        'immediateThreatment',
        (this.state.model?.carType === CarType.NC.Code || 
         this.state.model?.carType === CarType.OBS.Code) ?
          this.state.model?.ca[0].immediateThreatment : true,
        'required'
      ),
      explain: this.validatorSolutions.message(
        'explain', 
        (this.state.model?.carType === CarType.NC.Code || 
         this.state.model?.carType === CarType.OBS.Code) ? 
          this.state.model?.ca[0].explain : true,
         'required'),
     } : null);

    const validationsEffectivenessCA = (this.state.isNewCarManagement !== 0 ? {
      checkEffectiveness: this.validatorEffectiveness.message(
        'checkEffectiveness',
        (this.state.model?.carType === CarType.NC.Code || 
         this.state.model?.carType === CarType.OBS.Code) ? 
          this.state.model?.ca[0].checkEffectiveness : true,
         'required'),
      dateCheck: this.validatorEffectiveness.message(
        'dateCheck', 
        (this.state.model?.carType === CarType.NC.Code || 
         this.state.model?.carType === CarType.OBS.Code) ? 
          this.state.model?.ca[0].dateCheck : true, 
        'required'),
        //RITM0945960 - Effectiveness Check Modification
        isCorrectiveActionsSuitable: this.validatorEffectiveness.message( 
            'isCorrectiveActionsSuitable',
            (this.state.model?.carType === CarType.NC.Code ||
                this.state.model?.carType === CarType.OBS.Code) ?
                this.state.model?.ca[0].isCorrectiveActionsSuitable : true,
            'required'),
        //End
    } : null);

    const FindingCADetailProps = {
      idAudit: this.state.idAuditEdit,
      idAnswer: this.state.idAnswer,
      idFinding: this.state.idCar,
      car: this.state.model,
      CAModel: this.state.model?.ca?.length > 0 ? this.state.model.ca[0] : null,
      updateState: this.updateStateCarCA,
      onUploadFile: this.onUploadFileCA, 
      onDeleteFile: this.onDeleteFileCA,
      validations: validationsCA,
      validationsSolution: validationCASolution,
      validationsEffectiveness: validationsEffectivenessCA
    };

    const canEditResource = this.state.model && {
      idCompiler: this.state.model.audit.checkList.idCompiler,
      idDataApprover: this.state.model.audit.checkList.idDataApprover,
      idDivisionManager: this.state.model.audit.checkList.idDivisionManager,
      email:
        this.state.model.owner != null
          ? this.state.model.owner.email
          : this.state.model.ownerSaipem != null
          ? this.state.model.ownerSaipem.email
          : this.state.model.genericOwner != null ?
            this.state.model.genericOwner.email : '',
    };

    const leadAuditor = (this.state.model && this.state.model.audit.auditors.find((x) => x.teamLeader === true).email) || ''; //RITM1149988

      return (
        <AppContext.Consumer>
          {({ user }) => (
            <>
              <PageBreadCrumb
                linkTo={this.getBackUrl()}
                linkText="FINDING List"
                titleLeft={`Audit Id: ${
                  (this.state.model && this.state.model.auditCode) || ''
                } - Finding Detail`}
                titleCenter={this.state.model && `ID: ${this.state.model.auditCARCode}`}
                titleRight={
                  this.state.model && this.state.model.status
                    ? this.state.isNewCarManagement ? 
                      this.state.model.status.findingName : 
                      this.state.model.status.carManagementName
                    : null
                }
                batchActions={this.getStatusActions(user, canEditResource)}
                showButtonHistory={this.showButtonHistory()}
              />
              <div className="mainContainer">
                {this.showLoading()}
                <WFActionModal
                  show={this.state.isApprovalModalOpen}
                  title={`${this.state.isNewCarManagement ? this.state.approvalModalAction.replace('Finding', '') : this.state.approvalModalAction} ${this.state.isNewCarManagement ? 'Finding' : 'Audit CARs'}`}
                  action={`${this.state.isNewCarManagement ? this.state.approvalModalAction.replace('Finding', '') : this.state.approvalModalAction}`}
                  withApprover={this.state.withApprover}
                  approver={this.state.approver}
                  approverRole={this.state.approverRole}
                  approverOptions={this.state.approvers}
                  isLoadingOperation={this.state.isLoadingWFOperation}
                  onApproverSelect={this.handleApproverSelect}
                  isLoadingOptions={this.state.isLoadingApproverOptions}
                  onCancel={this.handleCloseApprovalModal}
                  onConfirm={this.handleConfirmApprovalModal}
                  onApprovalNotesChange={this.handleApprovalNotesChange}
                  approvalNotes={this.state.approvalNotes}
                  approvalNotesRequired={this.state.approvalNotesRequired}
                  validationMessages={this.state.approvalValidationMessages}
                />
                          <HistoryTable
                              entityId={this.state.idCar}
                              isOpenModal={this.state.isHistoryModalOpen}
                              onClose={() => this.closeModalHistory()}
                              masked={this.state.model?.audit?.maskedValue} //RITM1133680 Start - Anonimization AUDIT Module
                          />

                {this.state.model &&
                (this.state.model.carType === CarType.NC.Code ||
                  this.state.model.carType === CarType.OBS.Code) ? (
                    <div className="bx--row">
                      <div className="bx--col-md-6 bx--col-lg-6">
                        <FormGroup legendText="Due Date">
                          <TextInput
                            id="dueDate1"
                            type="text"
                            labelText=""
                            className="bx--text-input disable-text"
                            defaultValue={switchDateFormat(this.state.model.dueDate, 'date')}
                            disabled
                          />
                        </FormGroup>
                      </div>
                      <div className="bx--col-md-6 bx--col-lg-6">
                        <FormGroup legendText="Status">
                          <TextInput
                            id="status"
                            type="text"
                            labelText=""
                            className="bx--text-input disable-text"
                            defaultValue={
                              this.state.model.status && this.state.isNewCarManagement ? 
                              this.state.model.status.findingName : 
                              this.state.model.status.carManagementName
                            }
                            disabled
                          />
                        </FormGroup>
                      </div>
                    </div>
                ) : (
                  ''
                )}

                {this.state.model && (
                  <div className="bx--row">
                    <div className="bx--col-lg-12 bx--col-md-12">
                      <FormGroup legendText="Details">
                        <TextArea
                          maxLength={5000}
                          id="inefficiency"
                          placeholder=""
                          value={this.state.model.inefficiency || ''}
                          hideLabel
                          labelText=""
                          light
                          rows={4}
                          cols={225}
                          disabled
                          className="disable-text"
                        />
                      </FormGroup>
                    </div>
                    <div className="bx--col-lg-12 bx--col-md-12">
                      <FormGroup legendText="Reference Documents">
                        <TextArea
                          maxLength={5000}
                          id="referenceDocuments"
                          placeholder=""
                          value={this.state.model.referenceDocuments || ''}
                          hideLabel
                          labelText=""
                          light
                          rows={4}
                          cols={225}
                          disabled
                          className="disable-text"
                        />
                      </FormGroup>
                    </div>
                  </div>
                )}

                {this.state.model ? (
                  <div className="bx--row">
                    <div className="bx--col-md-6 bx--col-lg-6">
                      <FormGroup legendText="Type">
                        <TextInput
                          id="type"
                          type="text"
                          labelText=""
                          className="bx--text-input disable-text"
                          defaultValue={GetCarTypeByCode(this.state.model.carType)?.Name || ''}
                          disabled
                        />
                      </FormGroup>
                    </div>
                    <div className="bx--col-md-6 bx--col-lg-6">
                      <FormGroup legendText="Project Finding Code">
                        <TextInput
                          id="findingCode"
                          type="text"
                          labelText=""
                          className="bx--text-input disable-text"
                          defaultValue={this.state.model.findingCode || ''}
                          disabled
                        />
                      </FormGroup>
                    </div>
                  </div>
                ) : (
                  ''
                )}
    
                {this.state.model && this.state.model.carType === CarType.NC.Code ? (
                  <div className="bx--row">
                    <div className="bx--col-md-6 bx--col-lg-6">
                      <FormGroup legendText="Finding/NC Level">
                        <TextInput
                          id="type"
                          type="text"
                          labelText=""
                          className="bx--text-input disable-text"
                          defaultValue={this.state.model.type || ''}
                          disabled
                        />
                      </FormGroup>
                    </div>
                  </div>
                  ) : (
                    ''
                  )}

                {this.state.model && (
                  <div className="bx--row">
                    <div className="bx--col-md-6 bx--col-lg-6">
                      <FormGroup legendText="Classification Type - List 1">
                        <TextInput
                          id="dr1"
                          type="text"
                          labelText=""
                          className="bx--text-input disable-text"
                          defaultValue={this.state.model.findingsLevel1}
                          disabled
                        />
                      </FormGroup>
                    </div>

                    <div className="bx--col-md-6 bx--col-lg-6">
                      <FormGroup legendText="Classification Type - List 2">
                        <TextInput
                          id="dr2"
                          type="text"
                          labelText=""
                          className="bx--text-input disable-text"
                          defaultValue={this.state.model.findingsLevel2}
                          disabled
                        />
                      </FormGroup>
                    </div>
                  </div>
                )}

                {this.state.model && (
                  <div className="bx--row">
                    <div className="bx--col-md-6 bx--col-lg-6">
                      <FormGroup legendText="Classification Type - List 3">
                        <TextInput
                          id="rc1"
                          type="text"
                          labelText=""
                          className="bx--text-input disable-text"
                          defaultValue={this.state.model.findingsLevel3}
                          disabled
                        />
                      </FormGroup>
                    </div>

                    <div className="bx--col-md-6 bx--col-lg-6">
                      <FormGroup legendText="Classification Type - List 4">
                        <TextInput
                          id="r2"
                          type="text"
                          labelText=""
                          className="bx--text-input disable-text"
                          defaultValue={this.state.model.findingsLevel4}
                          disabled
                        />
                      </FormGroup>
                    </div>
                  </div>
                )}

                {this.state.model &&
                (this.state.model.carType === CarType.NC.Code ||
                  this.state.model.carType === CarType.OBS.Code) ? (
                    <div className="bx--row">
                      <div className="bx--col-md-6 bx--col-lg-6">
                        {/* RITM1133680 */}
                        <FormGroup legendText="Owner">
                          <TextInput
                            id="txt-name"
                            type="text"
                            labelText=""
                            className="bx--text-input disable-text"
                            defaultValue={
                              this.state.model.owner
                                ? (this.state.model?.audit?.maskedValue 
                                  ? (this.state.model.owner.name != null 
                                    ? this.state.model.owner.name : (this.state.model.owner.surname != null 
                                      ? this.state.model.owner.surname : `${this.state.model.owner.name} ${this.state.model.owner.surname}`)) 
                                  : `${this.state.model.owner.name} ${this.state.model.owner.surname}`)
                                : this.state.model.genericOwner 
                                  ? (this.state.model?.audit?.maskedValue 
                                    ? (this.state.model.genericOwner.name != null 
                                      ? this.state.model.genericOwner.name : (this.state.model.genericOwner.surname != null 
                                        ? this.state.model.genericOwner.surname : `${this.state.model.genericOwner.name} ${this.state.model.genericOwner.surname}`))
                                    : `${this.state.model.genericOwner.name} ${this.state.model.genericOwner.surname}`) 
                                  : (this.state.model?.audit?.maskedValue 
                                    ? (this.state.model.ownerSaipem.name != null 
                                      ? this.state.model.ownerSaipem.name : (this.state.model.ownerSaipem.surname != null 
                                        ? this.state.model.ownerSaipem.surname : `${this.state.model.ownerSaipem.name} ${this.state.model.ownerSaipem.surname}`)) 
                                    : `${this.state.model.ownerSaipem.name} ${this.state.model.ownerSaipem.surname}`)
                            }
                            disabled
                          />
                        </FormGroup>
                      </div>

                      <div className="bx--col-md-6 bx--col-lg-6">
                        <FormGroup legendText="Actual date of completion of Finding">
                          {!this.state.model ? (
                            <DatePickerSkeleton />
                          ) : (
                            <DateTimePicker
                              value={this.state.model?.actualDateCompletition}
                              type="date"
                              disableFutureDate
                              placeholder={DateFormat}
                              name="actualDateCompletition"
                              alt="actualDateCompletition"
                              onChange={this.updateActualCompletion}
                              disabled={!IsEditable('Audit', this.state.isNewCarManagement === 0 ? 'CARManagement' : 'FindingManagement', user, this.state.model?.idStatus ?? null, 'ActualDateCompletition', canEditResource)}
                            />
                        )}
                        </FormGroup>
                      </div>
                    </div>
                ) : (
                  ''
                )}

                <AttachmentTable
                  storagePath="audit"
                  model={this.state.model}
                  items={this.state.model?.attachment}
                  apiDownloadUrl={`/audit/${this.state.model?.idAudit}/answer/${this.state.model?.idAnswer}/car/${this.state.model?.id}/attachment/`}
                  onUploadFIle={this.onUploadFiles}
                  onDeleteFile={this.onRemoveFile}
                  isDisabled={!IsEditable('Audit', this.state.isNewCarManagement === 0 ? 'CARManagement' : 'FindingManagement', user, this.state.model?.idStatus ?? null, 'Attachments', canEditResource)}
                />
                {this.state.isNewCarManagement !== 0 && this.state.model &&
                  (this.state.model.carType === CarType.NC.Code ||
                    this.state.model.carType === CarType.OBS.Code) ?
                      <AuditFindingCADetail
                        {...FindingCADetailProps}
                        user={user}
                        leadAuditor={leadAuditor} //RITM1149988
                        showCADefinition={this.state.model?.idStatus >= 2}
                        isDisabled={!IsEditable('Audit', 'FindingManagement', user, this.state.model?.idStatus ?? null, 'CADefinition', canEditResource)}
                        editEffectiveness={IsEditable('Audit', 'FindingManagement', user, this.state.model?.idStatus ?? null, 'Effectiveness', canEditResource)}
                        showCASolution={this.state.model?.idStatus >= 4}
                        isDisabledCAManagement={!IsEditable('Audit', 'FindingManagement', user, this.state.model?.idStatus ?? null, 'CAManagement', canEditResource)}
                      />
                    : null}

                {IsEditable('Audit', this.state.isNewCarManagement === 0 ? 'CARManagement' : 'FindingManagement', user, this.state.model ? this.state.model.idStatus : null, this.state.isNewCarManagement === 0 ? 'ActualDateCompletition' : (this.state.model?.idStatus >=4 ? 'ActualDateCompletition' : 'Attachments'), canEditResource) ? ( //RITM0993945
                  <div className="bx--row" style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', flexWrap: 'nowrap', marginBottom: '50px' }}>
                    <Button style={{ width: '100%' }} kind="primary" onClick={this.state.isNewCarManagement === 0 ? () => this.save() : () => this.saveNewMng()}> Save</Button>
                  </div>
                  ) : null}

                {this.state.isNewCarManagement === 0 && this.state.model &&
                (this.state.model.carType === CarType.NC.Code ||
                  this.state.model.carType === CarType.OBS.Code) ? (
                    <div className="bx--row">
                      <div className="bx--col-lg-12">
                        <AuditCAList
                          {...CAListProps}
                          user={user}
                          car={this.state.model}
                          isDisabled={
                            !IsEditable(
                              'Audit',
                              'CARManagement',
                              user,
                              this.state.model ? this.state.model.idStatus : null,
                              'CA',
                              canEditResource
                            )
                          }
                        />
                      </div>
                    </div>
                ) : (
                  ''
                )}
              </div>
            </>
          )}
        </AppContext.Consumer>
    );
  }
}
